import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { Apitoken, Authtoken } from "../Global";
import { loader_image } from "../_components/Imagepath";
import $ from "jquery";

const ViewProductionOutput = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [permission, setPermission] = useState({});
   let season_id = localStorage.getItem("season_id");

  useEffect(() => {
        setPermission(FindModuleById(51)); 
      console.log(permission);

  
    axios
      .get(`/production-output/view/${season_id+'-'+id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setValue(response.data.data.production);
          
            //if (response.data.data.production.pallet_type == 4 || response.data.data.production.pallet_type == 5 || response.data.data.production.pallet_type == 6) {  
          if ([4, 5, 6].includes(Number(response.data.data.production.pallet_type))) {
              $(".caliber-column").css("display", 'none');
            }   else {
              $(".caliber-column").css("display", 'contents');
            }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const handleDownload = async () => {
       let season_id = localStorage.getItem("season_id");

    $("#loader-image").removeClass('loader-hide');
    $("#loader-image").addClass('loader-show');
    var barcode_number = value.barcode_number;
    axios.get(`/production-output/pdf/${season_id+'-'+id}`, {
      responseType: 'blob',
    headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }
  }).then(response => {
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      let file_name = barcode_number +'.pdf';
      link.download = file_name;
      link.click();
      $("#loader-image").addClass('loader-hide');
        $("#loader-image").removeClass('loader-show');
  })
  .catch(error => {
      console.error('Error downloading PDF:', error);
  });

  };

  const editItem = ()=>{
    window.location.href = "/production-output-edit/"+id;
  }
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Production Output</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/production-output">Production Output</Link>
                    </li>
                    <li className="breadcrumb-item active">
                      View Production Output
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                {permission?.list == 1 && (
                  <div className="card-body">
                    <h4 className="card-title">View Production Output Info</h4>
                    <div style={{float:"right"}}>
                    <button   onClick={() => editItem()}   className="btn btn-danger me-1"  > Edit Production Output </button>
                   
                      <button   onClick={() => handleDownload()}   className="btn btn-primary me-1"  > Download Production Output <i className="fa fa-print" /> <img id="loader-image" className="loader-image loader-hide" src={loader_image}/>  </button>
                    </div>
                    <table className="table table-bordered">
                      <tr>
                        <th className="p-3">Barcode Number</th>
                        <td className="p-3">{value.barcode_number}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Date Time</th>
                        <td className="p-3">{value.date_time}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Shift</th>
                        <td className="p-3">{value.shift}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Shift Date</th>
                        <td className="p-3">{value.shift_date}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Location</th>
                        <td className="p-3">
                          {value.location ? value.location_name.title : ""}
                        </td>
                      </tr>
                      {/* <tr>
                        <th className="p-3">Caliber</th>
                        <td className="p-3">{value.calibre}</td>
                      </tr> */}
                      <tr>
                        <th className="p-3">Order PO Number</th>
                        <td className="p-3">
                          {value.order ? value.order_detail.po_number : ""}
                        </td>
                      </tr>
                      <tr>
                        <th className="p-3">Packaging Type</th>
                        <td className="p-3">
                          {value.package_type ? value.package_type.title : ""}

                        {/* {value.package_type && value.package_type.title ? value.package_type.consumable_name : value.package_type.title} */}
                        </td>
                      </tr>
                      <tr>
                        <th className="p-3">Palletisation Type</th>
                        <td className="p-3">
                          {value.pallet_type
                            ? value.pallet_type_title.title
                            : ""}
                        </td>
                      </tr>
                   
                      <tr>
                        <th className="p-3">Remark</th>
                        <td className="p-3">{value.remark}</td>
                      </tr>
                    </table>
                    <br />
                    <h5 className="card-title">Order Items</h5>

                    <table className="table table-bordered">
                      <tr>
                        <th className="p-3 caliber-column" style={{display: [4, 5, 6].includes(Number(value.pallet_type)) ? 'none' : 'block'}}>Caliber</th>
                        <th className="p-3">Product</th>
                        <th className="p-3 caliber-column" style={{display: [4, 5, 6].includes(Number(value.pallet_type)) ? 'none' : 'block'}}>Lot Number</th>
                        <th className="p-3">Raw Raterial Lot Number</th>
                        <th className="p-3">No Of Boxes</th>
                        <th className="p-3">Gross Weight </th>
                        <th className="p-3">Net Weight </th>
                      </tr>

                      {value.contents &&
                          value.contents.map((item, indx) => (
                            <tr key={item.calibre || indx}>
                              <td className="p-3 caliber-column" style={{display: [4, 5, 6].includes(Number(value.pallet_type)) ? 'none' : 'block'}}>
                                {item.calibre}
                              </td>
                              <td className="p-3">{item.product_name}</td>
                              <td className="p-3 caliber-column" style={{display: [4, 5, 6].includes(Number(value.pallet_type)) ? 'none' : 'block'}}>
                                {item.lot_number}
                              </td>
                              <td className="p-3">{item.raw_material_lot_number}</td>
                              <td className="p-3">{item.number_of_boxes}</td>
                              <td className="p-3">{item.gross_weight}KG</td>
                              <td className="p-3">{item.net_weight}KG</td>
                            </tr>
                          ))}
                    </table>
                  </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ViewProductionOutput;
